"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    windMachineActivity: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
    windMachineActivityIntervals: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
    windMachineBattery: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
    windMachineCycles: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    windMachineFuel: _aggregation_helpers_1.dailyOrUnAggregatedOnlyAggregationIntervalHelper,
    windMachineRPM: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
    windMachineRunTime: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    windMachineSettings: _aggregation_helpers_1.dailyOrUnAggregatedOnlyAggregationIntervalHelper,
    windMachineTemperature: _aggregation_helpers_1.dailyOrUnAggregatedOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=wind_machine.js.map